import clsx from 'clsx';

import { usePortalLocale } from '@/lib/i18n/PortalLocaleContext';

/**
 * One-tap language switch in the Portal header. It shows the language it
 * switches TO, written in that language, so a parent who cannot read the
 * current language can still find it.
 */
export function PortalLanguageToggle() {
  const { locale, setLocale, t } = usePortalLocale();
  const next = locale === 'zh' ? 'en' : 'zh';
  const label = next === 'zh' ? t('Switch to Chinese') : t('Switch to English');

  return (
    <button
      type="button"
      onClick={() => setLocale(next)}
      aria-label={label}
      title={label}
      lang={next === 'zh' ? 'zh-CN' : 'en-AU'}
      className={clsx(
        'flex h-11 min-w-11 shrink-0 items-center justify-center rounded-full border border-hairline bg-canvas-pure px-3 text-sm font-bold text-ink transition-colors',
        'hover:border-ink/25 hover:bg-canvas focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-coral',
      )}
      data-testid="portal-language-toggle"
    >
      {next === 'zh' ? '中文' : 'EN'}
    </button>
  );
}
